import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../ui';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../app/providers';
import { qk } from '../dashboard/queries';

/** Managers choose whether viewers of this board see the comments (spec §9.2, default yes). */
export function ViewerCommentsToggle({ boardId }: { boardId: string }) {
  const { t } = useTranslation();
  const api = useApi();
  const queryClient = useQueryClient();
  const access = useQuery({ queryKey: qk.board(boardId), queryFn: () => api.getBoard(boardId) });
  if (!api.capabilities.comments || !access.data) return null;
  return (
    <Checkbox
      label={t('comments.viewerComments')}
      checked={access.data.board.viewerComments}
      onCheckedChange={async (checked) => {
        await api.updateBoard(boardId, { viewerComments: checked });
        await queryClient.invalidateQueries({ queryKey: qk.board(boardId) });
      }}
      className="mb-4"
    />
  );
}
